const navigation = document.querySelectorAll('.vg-nav-wrapper li a');
const btnContact = document.querySelector('.btn-gta2');

const targetScroll = (el, event, link) => {
	event.preventDefault();
	let id = el.getAttribute('href').slice(1);
	let container = document.querySelector(id);
	let offset = container.offsetTop - 80;
	if(id === link) {
		offset = container.offsetTop - 100;
	}
	window.scrollTo({
		top: offset,
		behavior: "smooth"
	})
};

if(navigation) {
	navigation.forEach((el) => {
		el.addEventListener('click', (e) => {
			targetScroll(el, e, '#products')
		})
	});
}

if(btnContact) {
	btnContact.addEventListener('click', (e) => {
		targetScroll(btnContact, e, '#gta2');
	})
}